module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-chalk-4-8a2c74b3e369891545ae6de7807b7743.png";